var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemoriesEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 182,
    viewBox: "0 0 240 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.891 85.064L102.641 50.064C100.473 48.7154 97.7413 48.644 95.5058 49.8774C93.2698 51.1108 91.8828 53.4553 91.8828 56V126C91.8828 128.545 93.2698 130.889 95.5058 132.123C96.568 132.709 97.7417 133 98.9141 133C100.209 133 101.503 132.644 102.641 131.936L158.891 96.936C160.947 95.6569 162.195 93.4136 162.195 91C162.195 88.5864 160.947 86.3432 158.891 85.064ZM105.946 113.37V68.6294L141.898 91L105.946 113.37Z",
    fill: "#49712B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204.846 0H35.1582C15.773 0 0.00195312 15.701 0.00195312 35V147C0.00195312 166.299 15.773 182 35.1582 182H204.846C224.231 182 240.002 166.299 240.002 147V35C240.002 15.701 224.231 0 204.846 0ZM225.939 147C225.939 158.579 216.477 168 204.846 168H35.1582C23.5271 168 14.0645 158.579 14.0645 147V35C14.0645 23.4206 23.5271 14 35.1582 14H204.846C216.477 14 225.939 23.4206 225.939 35V147Z",
    fill: "#49712B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemoriesEmpty);
export default __webpack_public_path__ + "static/media/memories-empty.8ae7498561211321643481993f455f35.svg";
export { ForwardRef as ReactComponent };